import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import { getClientAuthToken } from '../../../client/token';


export default class FileDownload extends PureComponent {
    constructor(props) {
        super(props);
        this.getFormInputs = this.getFormInputs.bind(this);
        this.state = {
            token: undefined
        };
    }

    getFormInputs() {
        const {queryParams} = this.props;

        if (queryParams === undefined) {
            return null;
        }

        return Object.keys(queryParams).map((name, index) => {
            return (
                <input key={index}
                       name={name}
                       type='hidden'
                       value={queryParams[name]}
                />
            );
        });
    }

    componentDidMount() {
        if (__CLIENT__) {
            this.setState({token: getClientAuthToken()});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.downloadPath) {
            this.refs.fileDownload.action = nextProps.downloadPath;
            this.refs.fileDownload.submit();
            if (this.props.onDownloadCompleted) {
                this.props.onDownloadCompleted(nextProps.downloadPath);
            }
        }

        if (__CLIENT__) {
            this.setState({token: getClientAuthToken()});
        }
    }

    render() {
        const {downloadPath, method} = this.props;

        return (
            <form ref='fileDownload'
                  className='hidden'
                  method={method}>

            <input key='accessToken'
                   name='accessToken'
                   type='hidden'
                   value={this.state.token}/>

            {this.getFormInputs()}
            </form>);
    }
}

FileDownload.propTypes = {
    downloadPath: PropTypes.string,
    method: PropTypes.string,
    queryParams: PropTypes.object,
    onDownloadCompleted: PropTypes.func.isRequired,
};

FileDownload.defaultProps = {
    method: 'POST'
};